import React, { useEffect, useState } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { coursesApi } from '../../api/client';
import CourseCreateForm from '../forms/CourseCreateForm';

const CoursesPage: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);

  const load = async () => {
    try {
      setItems(await coursesApi.list());
    } catch (e: any) {
      setError(e?.response?.data?.error || e.message);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (creating) {
    return (
      <CourseCreateForm
        onCancel={() => setCreating(false)}
        onCreated={async () => {
          setCreating(false);
          await load();
        }}
      />
    );
  }

  return (
    <Box>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Courses ({items.length})</h3>
        <button type="button" onClick={() => setCreating(true)} style={{ padding: '0.5rem 1rem', backgroundColor: '#1976d2', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          + Create New Course
        </button>
      </div>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {items.map((c) => (
        <Box key={c.id} sx={{ p: '1.5rem', mb: 2, border: '1px solid #e0e0e0', borderRadius: '8px', bgcolor: 'white', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Typography sx={{ color: '#1976d2', fontWeight: 700 }}>{c.title}</Typography>
          <Typography variant="body2">{c.description || 'No description'}</Typography>
          <Typography variant="body2">
            Pass score: {c.passingScore ?? '—'} · Quiz Qs: {c.quiz?.length || 0} · {c.category || 'Uncategorized'}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CoursesPage;
